import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/metodos-de-pago';

/**
 * GET Metodos de pagos
 * @returns {Promise<object[]>}
 */
export const getMetodosDePagos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
   * GET Metodo de pago
   * @param {number} id
   * @returns {Promise<object|null>}
   */
export const getMetodoDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
   * POST Metodo de pago
   * @param {object} values
   * @returns {Promise<object|boolean>}
   */
export const postMetodoDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
   * PATCH Metodo de pago
   * @param {number} id
   * @param {object} values
   * @returns {Promise<object|boolean>}
   */
export const patchMetodoDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
   * DELETE Metodos de pagos
   * @param {number} id
   * @returns {Promise<boolean>}
   */
export const deleteMetodoDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
